import ActivityRosterBuilderApi from 'api/activityRosterBuilderApi';
import RosterApi from '../api/rosterApi';
import ActionsApi from '../api/actionsApi';
import CommentsApi from '../api/commentsApi';
import NotificationsApi from '../api/notificationsApi';
import ActivityTemplateApi from '../api/activityTemplateApi';
import ActivityApi from '../api/activityApi';
import AvailabilityApi from '../api/availabilityApi';
import PeopleDataApi from '../api/peopleApi';
import TagApi from '../api/tagApi';
import TravelApi from '../api/travelApi';
import CompetenciesApi, { UserCompetencyApi } from '../api/competencyApi';
import PermissionsApi from '../api/permissionsApi';
import IcalApi from '../api/icalApi';
import ReportsApi from '../api/reportsApi';
import ObjectHistoryApi from '../api/objectHistoryApi';

const REDUCER_KEY = {
  comments: {
    key: 'comments',
    type: 'list',
    action: {
      list: params => CommentsApi.getAllComments(params)
    }
  },
  comment: {
    key: 'comment',
    type: 'item',
    action: {
      load: params => CommentsApi.getComment(params),
      update: params => CommentsApi.updateComment(params),
      add: params => CommentsApi.addComment(params),
      remove: params => CommentsApi.deleteComment(params)
    }
  },
  commentThemes: {
    key: 'commentThemes',
    type: 'list',
    action: {
      list: params => CommentsApi.getAllCommentThemes(params)
    }
  },
  availabilityLeaveTypes: {
    key: 'availabilityLeaveTypes',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllAvailabilityLeaveTypes(params)
    }
  },
  availabilityLeaveType: {
    key: 'availabilityLeaveType',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getAvailabilityLeaveType(params),
      add: params => AvailabilityApi.createAvailabilityLeaveType(params),
      update: params => AvailabilityApi.updateAvailabilityLeaveType(params),
      remove: params => AvailabilityApi.deleteAvailabilityLeaveType(params)
    }
  },
  availabilityLeaveStatuses: {
    key: 'availabilityLeaveStatuses',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllAvailabilityLeaveStatus(params)
    }
  },
  availabilityLeaveStatus: {
    key: 'availabilityLeaveStatus',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getAvailabilityLeaveStatus(params),
      add: params => AvailabilityApi.createAvailabilityLeaveStatus(params),
      update: params => AvailabilityApi.updateAvailabilityLeaveStatus(params),
      remove: params => AvailabilityApi.deleteAvailabilityLeaveStatus(params)
    }
  },
  availabilityLeaveList: {
    key: 'availabilityLeaveList',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllAvailabilityLeave(params)
    }
  },
  availabilityLeave: {
    key: 'availabilityLeave',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getAvailabilityLeave(params),
      add: params => AvailabilityApi.createAvailabilityLeave(params),
      update: params => AvailabilityApi.updateAvailabilityLeave(params),
      remove: params => AvailabilityApi.deleteAvailabilityLeave(params)
    }
  },
  icalItems: {
    key: 'icalItems',
    type: 'list',
    action: {
      list: params => IcalApi.getUserUrls(params)
    }
  },
  icalItem: {
    key: 'icalItem',
    type: 'item',
    action: {
      load: params => IcalApi.getItem(params),
      add: params => IcalApi.createItem(params),
      remove: params => IcalApi.deleteItem(params)
    }
  },
  /* ICal Reducers - End */
  /* Tag Reducers - Start */
  themes: {
    key: 'themes',
    type: 'list',
    action: {
      list: params => TagApi.getTagThemes(params)
    }
  },
  tags: {
    key: 'tags',
    type: 'list',
    action: {
      list: params => TagApi.getAllTags(params)
    }
  },
  tag: {
    key: 'tag',
    type: 'item',
    action: {
      load: params => TagApi.getTag(params),
      add: params => TagApi.createTag(params),
      update: params => TagApi.updateTag(params),
      remove: params => TagApi.deleteTag(params)
    }
  },
  tagValues: {
    key: 'tagValues',
    type: 'list',
    action: {
      list: params => TagApi.getAllTagValues(params)
    }
  },
  tagValue: {
    key: 'tagValue',
    type: 'item',
    action: {
      load: params => TagApi.getTagValue(params),
      add: params => TagApi.createTagValue(params),
      update: params => TagApi.updateTagValue(params),
      remove: params => TagApi.deleteTagValue(params)
    }
  },
  sharedItemTags: {
    key: 'sharedItemTags',
    type: 'list',
    action: {
      list: params => TagApi.getAllItemTags(params),
      add: params => TagApi.bulkCreateItemTags(params),
      remove: params => TagApi.bulkDeleteItemTags(params)
    }
  },
  sharedItemTag: {
    key: 'sharedItemTag',
    type: 'item',
    action: {
      load: params => TagApi.getItemTag(params),
      add: params => TagApi.createItemTag(params),
      update: params => TagApi.updateItemTag(params),
      remove: params => TagApi.deleteItemTag(params)
    }
  },
  itemTags: {
    key: 'itemTags',
    type: 'list',
    action: {
      list: params => TagApi.getAllItemTags(params),
      add: params => TagApi.bulkCreateItemTags(params),
      remove: params => TagApi.bulkDeleteItemTags(params)
    }
  },
  itemTag: {
    key: 'itemTag',
    type: 'item',
    action: {
      load: params => TagApi.getItemTag(params),
      add: params => TagApi.createItemTag(params),
      update: params => TagApi.updateItemTag(params),
      remove: params => TagApi.deleteItemTag(params)
    }
  },
  userItemTags: {
    key: 'userItemTags',
    type: 'list',
    action: {
      list: params => TagApi.getAllItemTags(params)
    }
  },
  collections: {
    key: 'collections',
    type: 'list',
    action: {
      list: params => TagApi.getAllTags(params)
    }
  },
  bookingCollectionValues: {
    key: 'bookingCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  userCollectionValues: {
    key: 'userCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  activityCollectionValues: {
    key: 'activityCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  competencyCollectionValues: {
    key: 'competencyCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  userleaveCollectionValues: {
    key: 'userleaveCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  templateCollectionValues: {
    key: 'templateCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  rosterBuilderCollectionValues: {
    key: 'rosterBuilderCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  assignmentCollectionValues: {
    key: 'assignmentCollectionValues',
    type: 'list',
    action: {
      list: params => TagApi.getCombinedTagCollectionValues(params)
    }
  },
  /* Tagged Items - Bulk User Tags */
  tagValuesForCollection: {
    key: 'tagValuesForCollection',
    type: 'list',
    action: {
      load: params => TagApi.getTagValuesForCollection(params)
    }
  },
  unAssignedTagUsers: {
    key: 'unAssignedTagUsers',
    type: 'list',
    action: {
      load: params => PeopleDataApi.getAllUsersWithSupervisor(params)
    }
  },
  assignedTagUsers: {
    key: 'assignedTagUsers',
    type: 'list',
    action: {
      load: params => PeopleDataApi.getAllUsersWithSupervisor(params),
      add: params => TagApi.addTagToUsers(params),
      remove: params => TagApi.removeTagFromUsers(params)
    }
  },
  /* Tag Reducers - End */
  /* Availability Reducers - Start */
  availabilityCycles: {
    key: 'availabilityCycles',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllCycles(params)
    }
  },
  availabilityCycle: {
    key: 'availabilityCycle',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getCycle(params),
      add: params => AvailabilityApi.createCycle(params),
      update: params => AvailabilityApi.updateCycle(params),
      remove: params => AvailabilityApi.deleteCycle(params)
    }
  },
  availabilityCycleLegs: {
    key: 'availabilityCycleLegs',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllCycleLegs(params)
    }
  },
  availabilityCycleLeg: {
    key: 'availabilityCycleLeg',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getCycleLeg(params),
      add: params => AvailabilityApi.createCycleLeg(params),
      update: params => AvailabilityApi.updateCycleLeg(params),
      remove: params => AvailabilityApi.deleteCycleLeg(params)
    }
  },
  availabilityLegs: {
    key: 'availabilityLegs',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllLegs(params)
    }
  },
  availabilityLeg: {
    key: 'availabilityLeg',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getLeg(params),
      add: params => AvailabilityApi.createLeg(params),
      update: params => AvailabilityApi.updateLeg(params),
      remove: params => AvailabilityApi.deleteLeg(params)
    }
  },
  availabilityLegTypes: {
    key: 'availabilityLegTypes',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllLegTypes(params)
    }
  },
  availabilityLegType: {
    key: 'availabilityLegType',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getLegType(params),
      add: params => AvailabilityApi.createLegType(params),
      update: params => AvailabilityApi.updateLegType(params),
      remove: params => AvailabilityApi.deleteLegType(params)
    }
  },
  /* Availability Reducers - End */
  /* Competency Reducers - Start */
  competencies: {
    key: 'competencies',
    type: 'list',
    action: {
      list: params => CompetenciesApi.getAllCompetencies(params)
    }
  },
  competency: {
    key: 'competency',
    type: 'item',
    action: {
      load: params => CompetenciesApi.getCompetency(params),
      add: params => CompetenciesApi.createCompetency(params),
      update: params => CompetenciesApi.updateCompetency(params),
      remove: params => CompetenciesApi.deleteCompetency(params)
    }
  },
  competencyTypes: {
    key: 'competencyTypes',
    type: 'list',
    action: {
      list: params => CompetenciesApi.getAllCompetencyTypes(params)
    }
  },
  competencyType: {
    key: 'competencyType',
    type: 'item',
    action: {
      load: params => CompetenciesApi.getCompetencyType(params),
      add: params => CompetenciesApi.createCompetencyType(params),
      update: params => CompetenciesApi.updateCompetencyType(params),
      remove: params => CompetenciesApi.deleteCompetencyType(params)
    }
  },
  competencyCheck: {
    key: 'competencyCheck',
    type: 'list'
  },
  unAssignedActivityCompetencies: {
    key: 'unAssignedActivityCompetencies',
    type: 'list',
    action: {
      load: params => CompetenciesApi.getAllCompetencies(params)
    }
  },
  assignedActivityCompetencies: {
    key: 'assignedActivityCompetencies',
    type: 'list',
    action: {
      load: params => CompetenciesApi.getAllCompetencies(params),
      add: params => ActivityApi.addActivityToCompetencies(params),
      remove: params => ActivityApi.removeActivityFromCompetencies(params)
    }
  },
  unAssignedCompetencyActivities: {
    key: 'unAssignedCompetencyActivities',
    type: 'list',
    action: {
      load: params => ActivityApi.getAllActivities(params)
    }
  },
  assignedCompetencyActivities: {
    key: 'assignedCompetencyActivities',
    type: 'list',
    action: {
      load: params => ActivityApi.getAllActivities(params),
      add: params => CompetenciesApi.addCompetencyToActivities(params),
      remove: params => CompetenciesApi.removeCompetencyFromActivities(params)
    }
  },
  unAssignedCompetencyUsers: {
    key: 'unAssignedCompetencyUsers',
    type: 'list',
    action: {
      load: params => CompetenciesApi.getUnassignedUsersForCompetency(params)
    }
  },
  assignedCompetencyUsers: {
    key: 'assignedCompetencyUsers',
    type: 'list',
    action: {
      load: params => CompetenciesApi.getAssignedUsersForCompetency(params),
      add: params => CompetenciesApi.addCompetencyToUsers(params),
      remove: params => CompetenciesApi.removeCompetencyFromUsers(params)
    }
  },
  actions: {
    key: 'actions',
    type: 'list',
    action: {
      list: params => ActionsApi.getAllActions(params)
    }
  },
  action: {
    key: 'action',
    type: 'item',
    action: {
      load: params => ActionsApi.getAction(params),
      add: params => ActionsApi.createAction(params),
      update: params => ActionsApi.updateAction(params),
      remove: params => ActionsApi.deleteAction(params)
    }
  },
  actionResolve: {
    key: 'action',
    type: 'item',
    action: {
      update: params => ActionsApi.actionResolve(params)
    }
  },
  actionTypes: {
    key: 'actionTypes',
    type: 'list',
    action: {
      list: params => ActionsApi.getAllActionTypes(params)
    }
  },
  actionType: {
    key: 'actionType',
    type: 'item',
    action: {
      load: params => ActionsApi.getActionType(params),
      add: params => ActionsApi.createActionType(params),
      update: params => ActionsApi.updateActionType(params),
      remove: params => ActionsApi.deleteActionType(params)
    }
  },
  actionStatusList: {
    key: 'actionStatusList',
    type: 'list',
    action: {
      list: params => ActionsApi.getAllActionStatus(params)
    }
  },
  actionPriorities: {
    key: 'actionPriorities',
    type: 'list',
    action: {
      list: params => ActionsApi.getAllActionPriorities(params)
    }
  },
  notifications: {
    key: 'notifications',
    type: 'list',
    action: {
      list: params => NotificationsApi.getAllNotifications(params)
    }
  },
  notification: {
    key: 'notification',
    type: 'item',
    action: {
      update: params => NotificationsApi.acknowledgeNotification(params)
    }
  },
  notificationTypes: {
    key: 'notificationTypes',
    type: 'list',
    action: {
      list: params => NotificationsApi.getAllNotificationTypes(params)
    }
  },
  notificationRules: {
    key: 'notificationRules',
    type: 'list',
    action: {
      list: params => NotificationsApi.getAllNotificationRules(params)
    }
  },
  notificationRule: {
    key: 'notificationRule',
    type: 'item',
    action: {
      load: params => NotificationsApi.getNotificationRule(params),
      add: params => NotificationsApi.addNotificationRule(params),
      update: params => NotificationsApi.updateNotificationRule(params),
      remove: params => NotificationsApi.deleteNotificationRule(params)
    }
  },
  notificationRuns: {
    key: 'notificationRuns',
    type: 'list',
    action: {
      list: params => NotificationsApi.getAllNotificationRuns(params)
    }
  },
  notificationRun: {
    key: 'notificationRun',
    type: 'item',
    action: {
      load: params => NotificationsApi.getNotificationRun(params),
      add: params => NotificationsApi.addNotificationRun(params),
      update: params => NotificationsApi.updateNotificationRun(params),
      remove: params => NotificationsApi.deleteNotificationRun(params)
    }
  },
  notificationTheme: {
    key: 'notificationTheme',
    type: 'list',
    action: {
      list: params => NotificationsApi.getNotificationTheme(params)
    }
  },
  actionContextList: {
    key: 'actionContextList',
    type: 'list',
    action: {
      list: params => ActionsApi.getAllActionContext(params)
    }
  },
  /* Competency Reducers - End */
  /* User Reducers - Start */
  peopleData: {
    key: 'peopleData',
    type: 'list',
    action: {
      list: params => PeopleDataApi.getAllUsers(params)
    }
  },
  users: {
    key: 'users',
    type: 'list',
    action: {
      list: params => PeopleDataApi.getAllUsers(params)
    }
  },
  userAccount: {
    key: 'userAccount',
    type: 'item',
    action: {
      load: params => PeopleDataApi.getUserAccount(params),
      add: params => PeopleDataApi.createUserAccount(params),
      update: params => PeopleDataApi.updateUserAccount(params)
    }
  },
  userProfile: {
    key: 'userProfile',
    type: 'item',
    action: {
      load: params => PeopleDataApi.getUserProfile(params),
      update: params => PeopleDataApi.updateUserProfile(params)
    }
  },
  userTravelProfile: {
    key: 'userTravelProfile',
    type: 'item',
    action: {
      load: params => PeopleDataApi.getUserTravelProfile(params),
      update: params => PeopleDataApi.updateUserTravelProfile(params)
    }
  },
  userTravelRoutes: {
    key: 'userTravelRoutes',
    type: 'item',
    action: {
      update: params => PeopleDataApi.updateUserTravelRoutes(params),
      load: params => PeopleDataApi.getUserTravelRoutes(params)
    }
  },
  userAvailabilityCycles: {
    key: 'userAvailabilityCycles',
    type: 'list',
    action: {
      list: params => AvailabilityApi.getAllUserCycles(params)
    }
  },
  userAvailabilityCycle: {
    key: 'userAvailabilityCycle',
    type: 'item',
    action: {
      load: params => AvailabilityApi.getUserCycle(params),
      add: params => AvailabilityApi.createUserCycle(params),
      update: params => AvailabilityApi.updateUserCycle(params),
      remove: params => AvailabilityApi.deleteUserCycle(params)
    }
  },
  userCompetencies: {
    key: 'userCompetencies',
    type: 'list',
    action: {
      list: params => UserCompetencyApi.getAllUserCompetencies(params)
    }
  },
  userCompetency: {
    key: 'userCompetency',
    type: 'item',
    action: {
      load: params => UserCompetencyApi.getUserCompetency(params),
      add: params => UserCompetencyApi.createUserCompetency(params),
      update: params => UserCompetencyApi.updateUserCompetency(params),
      remove: params => UserCompetencyApi.deleteUserCompetency(params)
    }
  },
  userGroups: {
    key: 'userGroups',
    type: 'list',
    action: {
      list: params => PermissionsApi.getUserGroups(params)
    }
  },
  unAssignedUserGroups: {
    key: 'unAssignedUserGroups',
    type: 'list',
    action: {
      load: params => PermissionsApi.getGroups(params)
    }
  },
  assignedUserGroups: {
    key: 'assignedUserGroups',
    type: 'list',
    action: {
      load: params => PermissionsApi.getUserGroups(params),
      add: params => PermissionsApi.addUserToGroups(params),
      remove: params => PermissionsApi.removeUserFromGroups(params)
    }
  },
  // Used in user reassign modal
  usersReassign: {
    key: 'usersReassign',
    type: 'list',
    action: {
      list: params => PeopleDataApi.getAllUsers(params)
    }
  },
  /* User Reducers - End */
  /* Travel Reducers - Start */
  travelLocations: {
    key: 'travelLocations',
    type: 'list',
    action: {
      list: params => TravelApi.getAllLocations(params)
    }
  },
  travelLocation: {
    key: 'travelLocation',
    type: 'item',
    action: {
      load: params => TravelApi.getLocation(params),
      add: params => TravelApi.createLocation(params),
      update: params => TravelApi.updateLocation(params),
      remove: params => TravelApi.deleteLocation(params)
    }
  },
  travelRoutes: {
    key: 'travelRoutes',
    type: 'list',
    action: {
      list: params => TravelApi.getAllRoutes(params)
    }
  },
  travelRoute: {
    key: 'travelRoute',
    type: 'item',
    action: {
      load: params => TravelApi.getRoute(params),
      add: params => TravelApi.createRoute(params),
      update: params => TravelApi.updateRoute(params),
      remove: params => TravelApi.deleteRoute(params)
    }
  },
  travelRouteTypes: {
    key: 'travelRouteTypes',
    type: 'list',
    action: {
      list: params => TravelApi.getAllRouteTypes(params)
    }
  },
  travelModes: {
    key: 'travelModes',
    type: 'list',
    action: {
      list: params => TravelApi.getAllTravelModes(params)
    }
  },
  travelLegs: {
    key: 'travelLegs',
    type: 'list',
    action: {
      list: params => TravelApi.getAllLegs(params)
    }
  },
  travelLeg: {
    key: 'travelLeg',
    type: 'item',
    action: {
      load: params => TravelApi.getLeg(params),
      add: params => TravelApi.createLeg(params),
      update: params => TravelApi.updateLeg(params),
      remove: params => TravelApi.deleteLeg(params)
    }
  },
  travelBookings: {
    key: 'travelBookings',
    type: 'list',
    action: {
      list: params => TravelApi.getAllBookings(params)
    }
  },
  travelBooking: {
    key: 'travelBooking',
    type: 'item',
    action: {
      load: params => TravelApi.getBooking(params),
      add: params => TravelApi.createBooking(params),
      update: params => TravelApi.updateBooking(params),
      remove: params => TravelApi.deleteBooking(params)
    }
  },
  travelItineraries: {
    key: 'travelItineraries',
    type: 'list',
    action: {
      list: params => TravelApi.getAllItineraries(params)
    }
  },
  travelItinerary: {
    key: 'travelItinerary',
    type: 'item',
    action: {
      load: params => TravelApi.getItinerary(params),
      add: params => TravelApi.createItinerary(params),
      update: params => TravelApi.updateItinerary(params),
      remove: params => TravelApi.deleteItinerary(params)
    }
  },
  travelStatuses: {
    key: 'travelStatuses',
    type: 'list',
    action: {
      list: params => TravelApi.getAllBookingStatuses(params)
    }
  },
  /* Travel Reducers - end */
  /* Roster Publish & Validation Reducers - Start */
  validators: {
    key: 'validators',
    type: 'list',
    action: {
      list: params => RosterApi.getAllValidators(params)
    }
  },
  validation: {
    key: 'validation',
    type: 'item',
    action: {
      load: params => RosterApi.getValidation(params),
      add: params => RosterApi.createValidation(params),
      update: params => RosterApi.editValidation(params),
      remove: params => RosterApi.deleteValidation(params)
    }
  },
  validations: {
    key: 'validations',
    type: 'list',
    action: {
      list: params => RosterApi.getAllValidations(params)
    }
  },
  validationTask: {
    key: 'validationTask',
    type: 'item',
    action: {
      load: params => RosterApi.getValidationTask(params),
      add: params => RosterApi.createValidationTask(params)
    }
  },
  validationTasks: {
    key: 'validationTasks',
    type: 'list',
    action: {
      list: params => RosterApi.getValidationTasks(params)
    }
  },
  validationRosterTasks: {
    key: 'validationRosterTasks',
    type: 'list',
    action: {
      list: params => RosterApi.getValidationTasks(params)
    }
  },
  publishStatus: {
    key: 'publishStatus',
    type: 'list'
  },
  /* Roster Publish & Validation Reducers - End */
  /* Roster Reducers - Start */
  rosters: {
    key: 'rosters',
    type: 'list',
    action: {
      list: params => RosterApi.getAllRosters(params)
    }
  },
  roster: {
    key: 'roster',
    type: 'item',
    action: {
      load: params => RosterApi.getRoster(params),
      add: params => RosterApi.createRoster(params),
      update: params => RosterApi.saveRoster(params)
    }
  },
  rosterVersions: {
    key: 'rosterVersions',
    type: 'list',
    action: {
      list: params => RosterApi.loadRosterVersions(params)
    }
  },
  rosterVersion: {
    key: 'rosterVersion',
    type: 'item',
    action: {
      load: params => RosterApi.getRosterVersion(params),
      add: params => RosterApi.createRosterVersion(params),
      update: params => RosterApi.saveRosterVersion(params),
      remove: params => RosterApi.deleteRosterVersion(params)
    }
  },
  /* Roster Reducers - Start */
  /* Template Reducers - Start */
  templates: {
    key: 'templates',
    type: 'list',
    action: {
      list: params => ActivityTemplateApi.getAllActivityTemplates(params)
    }
  },
  template: {
    key: 'template',
    type: 'item',
    action: {
      load: params => ActivityTemplateApi.getActivityTemplate(params),
      add: params => ActivityTemplateApi.createActivityTemplate(params),
      update: params => ActivityTemplateApi.updateActivityTemplate(params),
      clone: params => ActivityTemplateApi.cloneActivityTemplate(params),
      remove: params => ActivityTemplateApi.deleteActivityTemplate(params)
    }
  },
  /* Template Reducers - End */

  /* RosterBuilder Reducers - Start */
  rosterBuilders: {
    key: 'rosterBuilders',
    type: 'list',
    action: {
      list: params => ActivityRosterBuilderApi.getAllActivityRosterBuilders(params)
    }
  },
  rosterBuilder: {
    key: 'rosterBuilder',
    type: 'item',
    action: {
      load: params => ActivityRosterBuilderApi.getActivityRosterBuilder(params),
      add: params => ActivityRosterBuilderApi.createActivityRosterBuilder(params),
      update: params => ActivityRosterBuilderApi.updateActivityRosterBuilder(params),
      clone: params => ActivityRosterBuilderApi.cloneActivityRosterBuilder(params),
      remove: params => ActivityRosterBuilderApi.deleteActivityRosterBuilder(params)
    }
  },
  /* Roster Builders Reducers - End */

  /* Activity Reducers - Start */
  activities: {
    key: 'activities',
    type: 'list',
    action: {
      list: params => ActivityApi.getAllActivities(params)
    }
  },
  assignmentActivities: {
    key: 'assignmentActivities',
    type: 'list',
    action: {
      list: params => ActivityApi.getAllActivities(params)
    }
  },
  activityList: {
    key: 'activityList',
    type: 'list',
    action: {
      list: params => ActivityApi.getAllActivities(params)
    }
  },
  activity: {
    key: 'activity',
    type: 'item',
    action: {
      load: params => ActivityApi.getActivity(params),
      add: params => ActivityApi.createActivity(params),
      update: params => ActivityApi.updateActivity(params),
      remove: params => ActivityApi.deleteActivity(params)
    }
  },
  assignedActivityTemplates: {
    key: 'assignedActivityTemplates',
    type: 'list',
    action: {
      list: params => ActivityApi.getActivityTemplates(params)
    }
  },
  /* Activity Reducers - End */

  /* Object audit history - Start */
  objectHistory: {
    key: 'objectHistory',
    type: 'list',
    action: {
      list: params => ObjectHistoryApi.getObjectHistory(params)
    }
  },
  objectHistoryThemes: {
    key: 'objectHistoryThemes',
    type: 'list',
    action: {
      list: params => ObjectHistoryApi.getObjectHistoryThemes(params)
    }
  },
  /* Object audit history - End */
  activityTypes: {
    key: 'activityTypes',
    type: 'list',
    action: {
      list: params => ActivityApi.getAllActivityTypes(params)
    }
  },
  activityType: {
    key: 'activityType',
    type: 'item',
    action: {
      load: params => ActivityApi.getActivityType(params),
      add: params => ActivityApi.createActivityType(params),
      update: params => ActivityApi.updateActivityType(params),
      remove: params => ActivityApi.deleteActivityType(params)
    }
  },
  /* Reports */
  reports: {
    key: 'reports',
    type: 'list',
    action: {
      list: params => ReportsApi.getAllReports(params)
    }
  },
  report: {
    key: 'report',
    type: 'item',
    action: {
      load: params => ReportsApi.getReport(params)
    }
  }
};

export default REDUCER_KEY;
